import Vue from 'vue';
import _ from 'lodash';
import path from 'path';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';

export default Vue.component('edit-pdf-menu', {
  template: require('./template.html'),
  name: 'edit-pdf-menu',
  mixins: [guid, uploader],
  components: {
    uploadProgress,
  },
  computed: {
    fileName() {
      return path.basename(this.droplet.pdfLink);
    },
  },
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      tempPath: '',
      bucketPath: `_droplet-assets/pdfMenu/${this.droplet._id}/`,
      prefix: 'drz_pdf_menu_',
      display: {
        text: '',
        newWindow: '',
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.text = this.droplet.text || '';
      this.display.newWindow = this.droplet.newWindow;
    },
    openUpload() {
      this.$refs.uploadFile.click();
    },
    async uploadPdf(e) {
      this.$validator.validateAll().then(async (result) => {
        // run only if file types and dimensions are correct
        if (result) {
          const evt = e;
          let newFile = [...evt.target.files];
          if (newFile.length > 0) {
            newFile = newFile[0];
            // clean up the file name for s3
            let fileName = path.basename(newFile.name);
            fileName = `${this.prefix}${_.trim(fileName)}`;
            fileName = _.replace(fileName, /\s+/g, '_');
            try {
              // send off to our s3 upload mixin
              const filePath = `/${this.bucketPath}${fileName}`;
              await this.uploadFile({
                file: `${this._sitePath}${filePath}`,
                body: newFile,
              });
              this.$store.dispatch('setDropletVal', {
                drp: this.droplet,
                key: 'pdfLink',
                val: filePath,
              });
            } catch (err) {
              if (!err.message.match(/aborted/gi)) {
                this.$log.error(err);
                await this._reportError({
                  error: err,
                  fn: 'uploadPdf',
                });
              }
            }
          }
          // reset value to null so we can get the "change" event to run
          // in any case. Even when the user selects the same file
          evt.target.value = null;
        }
      });
    },
    setDropletVal() {
      this._debounce(() => {
        const val = this.display.text.trim() !== '' ? this.display.text : false;
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'text',
          val,
        });
      }, 200);
    },
    updateNewWindow() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'newWindow',
        val: this.display.newWindow,
      });
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/pdf-menu/components/_edit-options/index.js